import { render, staticRenderFns } from "./merchantNoList.vue?vue&type=template&id=4f561670&scoped=true"
import script from "./merchantNoList.vue?vue&type=script&lang=js"
export * from "./merchantNoList.vue?vue&type=script&lang=js"
import style0 from "./merchantNoList.vue?vue&type=style&index=0&id=4f561670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f561670",
  null
  
)

export default component.exports